import { useQuery } from "@tanstack/react-query";
import { getLicenseApplications } from "../api/licenseApplicationApi";
import { licenseApplicationKeys } from "../api/licenseApplicationKeys";

export const useLicenseApplications = () =>
  useQuery({
    queryKey: licenseApplicationKeys.list(),
    queryFn: getLicenseApplications,
  });
